import { render, staticRenderFns } from "./IngredientGroupBox.vue?vue&type=template&id=82f5d674&"
import script from "./IngredientGroupBox.vue?vue&type=script&lang=js&"
export * from "./IngredientGroupBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports